"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireWildcard(require("../../../Icon"));

require("./NotificationItem.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationItem = function NotificationItem(_ref) {
  var id = _ref.id,
      subject = _ref.subject,
      date = _ref.date,
      text = _ref.text,
      _onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "NotificationItem"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__title"
  }, subject), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__date"
  }, date), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__description"
  }, text), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification__read",
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return _onClick(id, subject, date, text);
    },
    onKeyPress: _onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: _Icon.ICON_TYPE_CLOSE
  })));
};

NotificationItem.propTypes = {
  /** The Notification id */
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** The Notification subject */
  subject: _propTypes.default.string,

  /** The Notification date */
  date: _propTypes.default.string,

  /** The Notification text */
  text: _propTypes.default.string,

  /** The Notification onClick */
  onClick: _propTypes.default.func
};
NotificationItem.defaultProps = {
  id: null,
  subject: null,
  date: null,
  text: null,
  onClick: function onClick() {}
};
var _default = NotificationItem;
exports.default = _default;